import { forwardRef, memo, type ReactNode } from 'react';

import { SearchCommandInput, type SearchCommandInputProps } from '~/components/SearchCommand/SearchCommandInput';
import {
  SmartSearchCommandInput,
  type SmartSearchCommandInputProps,
} from '~/components/SearchCommand/SmartSearchCommandInput';

export type SearchCommandInputBaseProps = (SearchCommandInputProps | SmartSearchCommandInputProps) & {
  canUseSmartSearch: boolean;
  children?: ReactNode;
  compact?: boolean;
  onVisualSearchClick: (() => void) | undefined;
  visualSearchTooltip: string;
};

export const SearchCommandInputBase = memo(
  forwardRef<HTMLInputElement, SearchCommandInputBaseProps>(
    (
      {
        children,
        compact,
        count,
        onValueChange,
        onVisualSearchClick,
        placeholder,
        value,
        canUseSmartSearch,
        visualSearchTooltip,
      }: SearchCommandInputBaseProps,
      ref,
    ) => {
      if (canUseSmartSearch) {
        return (
          <SmartSearchCommandInput
            compact={compact}
            count={count}
            onValueChange={onValueChange}
            onVisualSearchClick={onVisualSearchClick}
            placeholder={placeholder}
            ref={ref}
            value={value}
            visualSearchTooltip={visualSearchTooltip}
          >
            {children}
          </SmartSearchCommandInput>
        );
      }

      return (
        <SearchCommandInput
          compact={compact}
          count={count}
          onValueChange={onValueChange}
          placeholder={placeholder}
          ref={ref}
          value={value}
        >
          {children}
        </SearchCommandInput>
      );
    },
  ),
);

SearchCommandInputBase.displayName = 'SearchCommandInputBase';
